import { Container, Grid2, Icon, IconButton } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { schoolBookingService } from "../../../_services/schoolBooking.service";
import { StandardTable } from "../../../_components/table/standard.table";
import { MRT_ColumnDef } from "material-react-table";
import { filter } from "rxjs";
import { TABLE_FILTER } from "../../../_const/tableFilter.const";
import { PaperTableHeader } from "../../../_components/table/header.table";
import { getDate } from "date-fns";
import { getDateFromString, getDateString } from "../../../_helpers/dateTime.helper";


export function FormSummaryIndex() {



    const { formId } = useParams<{ formId: string }>();
    const [data, setData] = useState<any>({ items: [], count: 10 });
    const [filter, setFilter] = useState({ ...TABLE_FILTER });

    const [isLoading, setLoading] = useState(false);


    useEffect(() => {
        fetchCosts();
    }, [formId])

    function fetchCosts() {
        if (formId == null) return;
        setLoading(true);

        return schoolBookingService
            .getCosts(formId)
            .then(
                (json) => {
                    setData({ items: json, count: json.length });
                }
            )
            .finally(() => {
                setLoading(false);
            });
    }

    function escapeHtml(value: string) {
        return value
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;");
    }

    function printSummary() {
        const first = (data.items ?? [])[0] ?? {};
        const specialistName = first.specialistName ?? "";
        const contactTeacher = first.contactTeacher ?? "";
        const rows = (data.items ?? []).map((row: any) => {
            const visitDate = row.sessionDateTime ? getDateFromString(row.sessionDateTime) : "";
            const visitType = row.sessionTypeName ?? "";
            const visitCategory = row.visitCategoryName ?? "";
            const className = row.className ?? "";
            const heritageVisitContent = row.heritageVisitContent ?? "";
            const cost = row.cost ? "€" + row.cost : "FREE";

            return `<tr><td>${escapeHtml(String(visitDate))}</td><td>${escapeHtml(String(visitType))}</td><td>${escapeHtml(String(visitCategory))}</td><td>${escapeHtml(String(className))}</td><td>${escapeHtml(String(heritageVisitContent))}</td><td>${escapeHtml(String(cost))}</td></tr>`;
        }).join("");

        const html = `<!DOCTYPE html><html><head><title>Summary</title><style>
            body { font-family: Helvetica, Arial, sans-serif; padding: 24px; color: #222; }
            h1 { font-size: 22px; margin: 0 0 16px; }
            .details { margin: 0 0 16px; }
            .details p { margin: 0 0 6px; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #d0d0d0; padding: 8px 12px; text-align: left; vertical-align: top; }
            th { background: #f3f3f3; }
        </style></head><body>
            <h1>Summary</h1>
            <div class="details">
                <p><strong>Specialist Name:</strong> ${escapeHtml(String(specialistName))}</p>
                <p><strong>Contact Teacher:</strong> ${escapeHtml(String(contactTeacher))}</p>
            </div>
            <table>
                <thead><tr><th>Visit Date</th><th>Visit Type</th><th>Visit Category</th><th>Class</th><th>Heritage Visit Content</th><th>Cost</th></tr></thead>
                <tbody>${rows}</tbody>
            </table>
        </body></html>`;

        const iframe = document.createElement("iframe");
        iframe.setAttribute("aria-hidden", "true");
        iframe.style.position = "fixed";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "0";
        iframe.style.left = "-9999px";
        iframe.srcdoc = html;
        iframe.onload = () => {
            const frameWindow = iframe.contentWindow;
            if (!frameWindow) {
                iframe.remove();
                return;
            }

            frameWindow.focus();
            frameWindow.print();
            window.setTimeout(() => iframe.remove(), 1000);
        };
        document.body.appendChild(iframe);
    }

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [

            {
                accessorKey: 'sessionDateTime',
                header: 'Visit Date',
                enableSorting: false,
                enableColumnFilter: false, accessorFn: (row) => <>{row.sessionDateTime != null ? getDateFromString(row.sessionDateTime) : ""}</>
            },
            {
                accessorKey: 'sessionTypeName',
                enableSorting: false,
                enableColumnFilter: false, header: 'Visit Type'
            },
            {
                accessorKey: 'visitCategoryName',
                enableSorting: false,
                enableColumnFilter: false, header: 'Visit Category'
            },
            {
                accessorKey: 'cost',
                enableSorting: false,
                enableColumnFilter: false,
                header: 'Cost',
                accessorFn: (row) => <>{row.cost ? "€" + row.cost : "FREE"}</>
            },
        ],
        []
    );

    return (
        <Grid2 size={{ xs: 12 }}>
            <PaperTableHeader title="Summary" buttons={[
                { icon: "print", label: "Print", onClick: printSummary }
            ]} />

            <StandardTable
                columns={columns}
                data={data}
                filter={filter}
                setFilter={setFilter}
                loading={isLoading}
                enableBottomToolbar={false}
            />
        </Grid2>
    );

}